import { render, staticRenderFns } from "./MsgAttachments.vue?vue&type=template&id=ad83d9f4&"
import script from "./MsgAttachments.vue?vue&type=script&lang=js&"
export * from "./MsgAttachments.vue?vue&type=script&lang=js&"
import style0 from "./MsgAttachments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports